// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — voice.styled.classic.js, новая — voice.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './voice.styled.classic';
import * as cp from './voice.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
